export const API_URL = "https://wwtchampionship.com/api";

export function translate(lang, en, es) {
  return lang === "es" && es ? es : en;
}

export function createMarkup(html) {
  return { __html: html };
}

export function isFieldError(array, val) {
  return array.includes(val);
}

export function scroll() {
  return window.jQuery("html, body").animate(
    {
      scrollTop: window.jQuery("#logo-background").height(),
    },
    200
  );
}

export function fmtCurrency(int, cents = 2) {
  const amt = int;
  return `${amt.toLocaleString("en-US", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: cents,
    maximumFractionDigits: cents,
  })}`;
}

const isBrowser = () => typeof window !== "undefined";

export const getValFromLS = (key, useSessionStorage = false) => {
  if (useSessionStorage) {
    return isBrowser() && window.sessionStorage.getItem(key)
      ? window.sessionStorage.getItem(key)
      : undefined;
  } else {
    return isBrowser() && window.localStorage.getItem(key)
      ? window.localStorage.getItem(key)
      : undefined;
  }
};

export const setValToLS = (key, val, useSessionStorage = false) => {
  if (isBrowser() && val) {
    useSessionStorage
      ? window.sessionStorage.setItem(key, val)
      : window.localStorage.setItem(key, val);
  } else {
    useSessionStorage
      ? window.sessionStorage.removeItem(key)
      : window.localStorage.removeItem(key);
  }
  return true;
};
